var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"attributes"},_vm._l((_vm.attributes),function(ref){
var name = ref.name;
var value = ref.value;
return _c('ProgramDetail',{key:name,staticClass:"attribute",attrs:{"name":name}},[_c('TextDelta',{staticClass:"value",domProps:{"textContent":_vm._s(value)}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }